export const ru = {
    'minus-phrase-list': 'Минус-фразы'
};
